module.exports = __webpack_public_path__ + "static/media/alert_partner_silver_x1_new.62bc3316.png";